module.exports = __webpack_public_path__ + "img/test02-2.55abb570.jpg";